module.exports = __webpack_public_path__ + "97249a18b73c0d7e2c48e905079b339e.svg";